<template>
    <div class="modal ver2 show" id="memberInformation_popup">
        <div class="modal_box">
            <div class="modal_head inner">
                <div class="h_left"></div>
                <div class="h_title">회원정보</div>
                <div class="h_right">
                    <button type="button" class="btn clear_btn close_btn"
                        @click="$emit('userDetailModalClose')"></button>
                </div>
            </div>
            <div class="modal_body inner">
                <div class="form_box">
                    <div class="input_box wid50">
                        <label for="mem_account" class="label_text">계정</label>
                        <input type="text" id="mem_account" class="input_text" :value="userDetail.email" readonly>
                    </div>
                    <div class="input_box date wid50">
                        <label for="mem_account" class="label_text">가입일</label>
                        <input type="text" id="mem_date" class="input_text datepicker" :value="userDetail.reg_date"
                            disabled>
                    </div>
                    <div class="input_box wid100">
                        <label for="mem_plan" class="label_text">사용 Plan</label>
                        <div class="input_item">
                            <input type="text" id="mem_plan" class="input_text input_plan"
                                :value="userDetail.end_date != null ? `${userDetail.start_date} ~ ${userDetail.end_date}` : '무료 인원'"
                                :data-plan="userDetail.type == null ? 'Free' : userDetail.type == 0 ? 'Basic' : 'Premium'"
                                disabled>
                            <button type="button" class="btn ver2 bold planChange_btn"
                                @click="callPlanChangePopup">변경</button>
                        </div>
                        <div class="planchage_popup" :class="{ 'show': showPlanChangePopup }">
                            <p class="title">Plan 선택</p>
                            <div class="btnbox">
                                <button type="button" class="plan_btn" :class="{ 'selected': userPlan == 1 }"
                                    data-plan="Premium" @click="changePlan(1)">Premium</button>
                                <button type="button" class="plan_btn" :class="{ 'selected': userPlan == 0 }"
                                    data-plan="Basic" @click="changePlan(0)">Basic</button>
                                <button type="button" class="plan_btn" :class="{ 'selected': userPlan == null }"
                                    data-plan="Free" @click="changePlan(null)">Free</button>
                            </div>
                            <p class="title">기간 선택</p>
                            <VueDatePicker range :enable-time-picker="false" v-model="rangeDate" :clearable="false"
                                :teleport="true" :disabled="userPlan == null" />
                            <div class="btn_box">
                                <button type="button" class="btn full change_btn" @click="reqChangePlan">변경</button>
                            </div>
                        </div>
                    </div>
                    <div class="input_box wid100">
                        <label for="mem_suspension" class="label_text">계정정지</label>
                        <div class="input_item">
                            <input type="text" id="mem_suspension" class="input_text" v-model="userBanCause">
                            <button type="button" class="btn ver2 bold" v-if="userDetail.is_ban == 0"
                                @click="banUserReq({ uid: userDetail.uid, ban_cause: userBanCause })">계정정지</button>
                            <button type="button" class="btn ver2 bold" v-else
                                @click="$emit('banUserReq', { uid: userDetail.uid, ban_cause: userBanCause })">정지해지</button>
                        </div>
                    </div>
                </div>
                <div class="tbl_wrap">
                    <div class="tbl_titbox">
                        <p class="tit">
                            결제내역 <span class="color">({{ userPayList.length }})</span>
                        </p>
                    </div>
                    <DataTable ref="table" :data="userPayList" class="tbl" :columns="columns" :options="dtOptions">
                    </DataTable>
                </div>
            </div>
            <div class="modal_pagination">
                <button type="button" class="page_btn prev_btn" @click="$emit('prevUserDetail', userDetail.uid)">
                    <img :src="`${$STATIC_URL}/admin/img/page_prev2.png`" alt="" class="icon">
                    <span class="txt">이전 보기</span>
                </button>
                <button type="button" class="page_btn next_btn" @click="$emit('nextUserDetail', userDetail.uid)">
                    <span class="txt">다음 보기</span>
                    <img :src="`${$STATIC_URL}/admin/img/page_next2.png`" alt="" class="icon">
                </button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { useStore } from 'vuex';
import { defineProps, defineEmits, watch, ref } from 'vue';
import { changePlanAPI, getUserPayList } from '@/api';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
DataTable.use(DataTablesCore);

const dtOptions = {
    paging: true,  // 페이지네이션 활성화
    searching: false,
    info: false,
    pageLength: 10,
    lengthChange: false,
    language: {
        emptyTable: '데이터가 없습니다.', // 메시지 변경
    },
}

const columns = [
    {
        data: 'pay_date', title: '결제일',
        createdCell: (td) => {
            td.classList.add('date');
        },
        render: (data) => {
            return `${data.split(' ')[0]}`
        }
    },
    {
        data: 'type', title: '항목',
        createdCell: (td) => {
            td.classList.add('tit');
        },
        render: (data) => {
            switch (data) {
                case 0: return 'Premium';
                case 1: return 'Basic';
            }
        }
    },
    {
        data: 'pricing', title: '금액', render: (data) => {
            return `<span class="bold">${data.toLocaleString()}</span>`
        }
    },
    {
        data: 'status', title: '결제', render: (data) => {
            switch (data) {
                case 1: return '<span class="badge complete">완료</span>';
                case 2: return '<span class="badge cancel">취소</span>';
                case 3: return '<span class="badge admin">관리자</span>';
            }
        }
    }
]

const emit = defineEmits(['banUserReq', 'prevUserDetail', 'nextUserDetail', 'userDetailModalClose']);
const store = useStore();

const props = defineProps({
    userDetail: {
        type: Object,
        default: () => ({})
    }
})
const userPayList = ref([]);


const showPlanChangePopup = ref(false);

// 반응형 데이터
const userBanCause = ref("");
const userPlan = ref("");
const rangeDate = ref('');


watch(
    () => props.userDetail, // props.userDetail 변경 감지
    async (newVal) => {
        userBanCause.value = newVal.ban_cause;
        userPlan.value = newVal.type;
        rangeDate.value = newVal.start_date && newVal.end_date
            ? [newVal.start_date, newVal.end_date]
            : [];
        const res = await getUserPayList(props.userDetail.uid)
        if (res.status == 200) {
            userPayList.value = res.data.payList
        }
    },
    { immediate: true, deep: true } // 초기값 설정 및 객체 내부 속성 감지
);

function banUserReq(data) {
    if (data.ban_cause == null) {
        store.commit('setInfoModal', '정지사유를 입력해주세요.');
        return;
    } else {
        emit('banUserReq', { uid: data.uid, ban_cause: data.ban_cause })
    }
}

function changePlan(plan) {
    if (plan == null) {
        rangeDate.value = []
    }
    userPlan.value = plan;
}

function callPlanChangePopup() {
    showPlanChangePopup.value = !showPlanChangePopup.value
}

async function reqChangePlan() {
    if (rangeDate.value[0] == null && userPlan.value != null) {
        store.commit('setInfoModal', '기간을 선택해주세요.');
        return;
    } else {
        await changePlanAPI({ uid: props.userDetail.uid, plan: userPlan.value, date: rangeDate.value, pid: props.userDetail.pid })
        store.commit('setRefreshModal', '변경되었습니다.');
    }
}

</script>

<style scoped>
.selected {
    border: 3px solid #7050F8 !important;
}

.change_btn {
    /* height: 20px; */
    margin-top: 10px
}
</style>
<style>
.tbl_wrap .tbl tbody tr td .badge.admin {
    color: #41B883;
    background: #f0f1f8;
}
</style>